import React from 'react';
import { connect } from 'react-redux';

import TabbedSections from 'components/menus/TabbedSections';
import Section from 'components/Section';
import Table, { TableColumn } from 'components/lists/Table';
import WYSIWYG from 'components/WYSIWYG';


// StyleGuide = containers/TakeQuizPage/lab-values-modal

class LabValuesModalClass extends React.Component {
  render() {
    const { staticData } = this.props;
    const labValues = Object.values(staticData.data.lab_values || {});

    return (
      <div className="LabValues">
        <TabbedSections styleVariant="QuestionModalTabs">
          {labValues.map(labValue => (
            <Section type="none" name={labValue.tab_name} key={labValue.id} className="p-2">
              {Object.values(labValue.sections).map(section => (
                <Table
                  key={section.id}
                  rowData={Object.values(section.items)}
                  className="mb-2"
                  rowBorder
                  headerBorder
                >
                  <TableColumn
                    className="lab-value-header"
                    cellValue={rowItem => (
                      <WYSIWYG>{rowItem.name}</WYSIWYG>
                    )}
                  >
                    <b>{section.heading}</b>
                  </TableColumn>
                  <TableColumn
                    className="lab-value-header"
                    cellValue={rowItem => (
                      <WYSIWYG className="lab-value-cell">{rowItem.ref_range}</WYSIWYG>
                    )}
                  >
                    <b>Reference Range</b>
                  </TableColumn>
                  <TableColumn
                    className="lab-value-header"
                    cellValue={rowItem => (
                      <WYSIWYG className="lab-value-cell">{rowItem.si_ref_intervals}</WYSIWYG>
                    )}
                  >
                    <b>SI Reference Intervals</b>
                  </TableColumn>
                </Table>
              ))}
            </Section>
          ))}
        </TabbedSections>
      </div>
    );
  }
}

function mapStateToProps({
  staticData
}) {
  return {
    staticData
  };
}

export default connect(mapStateToProps, null)(LabValuesModalClass);
